module.exports = __webpack_public_path__ + "img/sitchBumper200px-min.png";